var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-padding padding-nav" },
    [
      _c(
        "el-button",
        {
          staticClass: "upper",
          staticStyle: { "margin-bottom": "0.16rem" },
          attrs: { type: "text", icon: "el-icon-d-arrow-left" },
          on: { click: _vm.goback },
        },
        [_vm._v("Go\n    back")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "vote-card" }, [
        _c("div", { staticClass: "vote-card-head" }, [
          _vm._v("Initiate Proposal"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "voteForm",
                staticClass: "vote-form page-form",
                attrs: {
                  model: _vm.pageData,
                  "label-position": "top",
                  rules: _vm.rules,
                },
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "title",
                      label: "Title",
                      rules: [
                        {
                          required: true,
                          message: "Please fill in",
                          trigger: "blur",
                        },
                      ],
                    },
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder:
                          "Please fill in, no more than 100 characters",
                        maxlength: "100",
                      },
                      model: {
                        value: _vm.pageData.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.pageData, "title", $$v)
                        },
                        expression: "pageData.title",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "description",
                      label: "Description",
                      rules: [
                        {
                          required: true,
                          message: "Please fill in",
                          trigger: "blur",
                        },
                      ],
                    },
                  },
                  [
                    _c("Toolbar", {
                      staticStyle: { "border-bottom": "1px solid #ccc" },
                      attrs: {
                        editor: _vm.editor,
                        defaultConfig: _vm.toolbarConfig,
                        mode: _vm.mode,
                      },
                    }),
                    _vm._v(" "),
                    _c("Editor", {
                      staticStyle: { height: "3rem", "overflow-y": "hidden" },
                      attrs: {
                        id: "textarea1",
                        defaultConfig: _vm.editorConfig,
                        mode: _vm.mode,
                      },
                      on: { onCreated: _vm.onCreated },
                      model: {
                        value: _vm.pageData.description,
                        callback: function ($$v) {
                          _vm.$set(_vm.pageData, "description", $$v)
                        },
                        expression: "pageData.description",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "spaceLeft vote-form-item" },
                  [
                    _c("div", [_vm._v("Duration")]),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: _vm.duration.toString(),
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticStyle: { color: "#fff" } }, [
                          _vm._v(_vm._s(_vm.duration.toFixed(4)) + " Day"),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { prop: "discussionUrl", label: "Discussion" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "eg: https://medium.com/@treasurenet_io",
                      },
                      model: {
                        value: _vm.pageData.discussionUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.pageData, "discussionUrl", $$v)
                        },
                        expression: "pageData.discussionUrl",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticClass: "spaceCenter",
                      staticStyle: { "margin-top": "0.4rem" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-cancel",
                          staticStyle: { "min-width": "1.6rem" },
                          on: {
                            click: function ($event) {
                              return _vm.cancel()
                            },
                          },
                        },
                        [_vm._v("Cancel\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "common-btn-blue-sm",
                          staticStyle: { "min-width": "1.6rem" },
                          on: {
                            click: function ($event) {
                              return _vm.next()
                            },
                          },
                        },
                        [_vm._v("\n              Next\n            ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("createDialog", { ref: "createDialog", on: { success: _vm.success } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }